{
  "name": "boarding-system",
  "version": "1.4.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build && npm run sentry:sourcemaps",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "version:start": "bash ./scripts/version_start.sh",
    "version:bump": "bash ./scripts/version_bump.sh",
    "version:end": "bash ./scripts/version_end.sh",
    "hotfix": "bash ./scripts/hotfix.sh",
    "changelog": "conventional-changelog -p angular -i CHANGELOG.md -s",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org sentry --project boarding-system ./dist/boarding-system && sentry-cli sourcemaps upload --org sentry --project boarding-system ./dist/boarding-system",
    "prepare": "husky"
  },
  "prettier": {
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^20.1.0",
    "@angular/compiler": "^20.1.0",
    "@angular/core": "^20.1.0",
    "@angular/forms": "^20.1.0",
    "@angular/platform-browser": "^20.1.0",
    "@angular/router": "^20.1.0",
    "@sentry/angular": "^10.5.0",
    "@sentry/cli": "^2.52.0",
    "@tailwindcss/postcss": "^4.1.11",
    "@zxing/browser": "^0.1.5",
    "@zxing/library": "^0.21.3",
    "@zxing/ngx-scanner": "^20.0.0",
    "html2canvas-pro": "^1.5.11",
    "intl-tel-input": "^25.3.1",
    "jspdf": "^3.0.1",
    "ngx-mask": "^20.0.3",
    "postcss": "^8.5.6",
    "pusher-js": "^8.4.0",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.1.11",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^20.1.0",
    "@angular/cli": "^20.1.0",
    "@angular/compiler-cli": "^20.1.0",
    "@ngx-env/builder": "^20.1.1",
    "@types/jasmine": "~5.1.0",
    "@types/jspdf": "^1.3.3",
    "angular-eslint": "20.1.1",
    "conventional-changelog": "^7.0.2",
    "conventional-changelog-angular": "^8.0.0",
    "eslint": "^9.29.0",
    "eslint-config-prettier": "^10.1.5",
    "eslint-plugin-prettier": "^5.5.1",
    "husky": "^9.1.7",
    "jasmine-core": "~5.8.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^16.2.7",
    "prettier": "3.6.2",
    "prettier-eslint": "^16.4.2",
    "typescript": "~5.8.2",
    "typescript-eslint": "8.34.1"
  }
}
